export default __webpack_public_path__ + "static/media/us.9acbcf10.svg";